import { clsx } from 'clsx';
import React, { forwardRef } from 'react';
import { createUseStyles } from 'react-jss';
import { TextStyles } from './Text.jss.js';
const useStyles = createUseStyles(TextStyles, {
  name: 'Text'
});
/**
 * The `Text` component can be used for embedding text into your app. You can hyphenate the text with the use of the `wrapping` prop.
 * <br />__Note:__ Line breaks will always be visualized except when the wrapping property is set to false. In addition, tabs and whitespace can be preserved by setting the renderWhitespace property to true.
 */
const Text = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    renderWhitespace,
    wrapping,
    className,
    style,
    slot,
    ...rest
  } = props;
  const classes = useStyles();
  const classNameString = clsx(classes.text, wrapping === false && classes.noWrap, renderWhitespace && classes.renderWhitespace, className);
  return /*#__PURE__*/React.createElement("span", {
    ref: ref,
    style: style,
    className: classNameString,
    slot: slot,
    ...rest
  }, children);
});
Text.defaultProps = {
  renderWhitespace: false,
  wrapping: true
};
Text.displayName = 'Text';
export { Text };